import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import sprintf from 'sprintf';

const CarouselNavigationItem = (props) => {
  const { index, activeIndex, activate, previewImageUrl, title } = props;
  const className = classNames('carousel-preview-navigation__item', {
    'carousel-preview-navigation__item--active': index === activeIndex,
  });
  let alt = title ? 'Preview %s' : 'Preview';
  alt = sprintf(alt, title);

  return (
    <div className='col-auto' style={{ maxWidth: 136, minWidth: 136 }}>
      <a
        href='#'
        onClick={(e) => {
          e.preventDefault();
          activate(index);
        }}
        className={className}
      >
        <img src={previewImageUrl} alt={alt} />
      </a>
    </div>
  );
};

CarouselNavigationItem.propTypes = {
  previewImageUrl: PropTypes.string.isRequired,
  activate: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  title: PropTypes.string,
};

CarouselNavigationItem.defaultProps = {
  title: null,
};

export { CarouselNavigationItem };
